function Home() {
  const courses = [
    // Senior Courses
    {
      tag: "Bestseller",
      name: "SPLASH",
      image: "splash",
      eligibility: "10th Pass",
      duration: "2 Years",
      description:
        "Complete Syllabus of 11th & 12th with focus on IIT-JEE & NEET",
    },
    {
      name: "SAGA",
      image: "saga",
      eligibility: "11th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 12th with focus on IIT-JEE & NEET",
    },
    {
      name: "SALEINT",
      image: "saleint",
      eligibility: "12th Pass",
      duration: "1 Year",
      description:
        "Complete Syllabus of 11th & 12th with focus on IIT-JEE & NEET",
    },

    // Class 7th
    {
      category: "Class 7",
      name: "Sprout (A)",
      image: "sprout",
      eligibility: "6th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 7th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 7",
      name: "Sprout (A+)",
      image: "sprout",
      eligibility: "6th Pass",
      duration: "4 Years",
      description:
        "Complete Syllabus of 7th to 10th with focus on NTSE / OLYMPIAD / KVPY",
    },
    {
      category: "Class 7",
      name: "Sprout (A++)",
      image: "sprout",
      eligibility: "6th Pass",
      duration: "6 Years",
      description:
        "Complete Syllabus of 7th to 12th with focus on IIT-JEE & NEET",
    },

    // Class 8th
    {
      category: "Class 8",
      name: "Sprout (A)",
      image: "sprout",
      eligibility: "7th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 8th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 8",
      name: "Sprout (A+)",
      image: "sprout",
      eligibility: "7th Pass",
      duration: "3 Years",
      description:
        "Complete Syllabus of 8th to 10th with focus on NTSE / OLYMPIAD / KVPY",
    },
    {
      category: "Class 8",
      name: "Sprout (A++)",
      image: "sprout",
      eligibility: "7th Pass",
      duration: "5 Years",
      description:
        "Complete Syllabus of 8th to 12th with focus on IIT-JEE & NEET",
    },

    // Class 9th
    {
      category: "Class 9",
      name: "Sprout (B)",
      image: "sprout",
      eligibility: "8th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 9th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 9",
      name: "Sprout (B+)",
      image: "sprout",
      eligibility: "8th Pass",
      duration: "2 Years",
      description:
        "Complete Syllabus of 9th to 10th with focus on NTSE / OLYMPIAD / KVPY",
    },
    {
      category: "Class 9",
      name: "Sprout (B++)",
      image: "sprout",
      eligibility: "8th Pass",
      duration: "4 Years",
      description:
        "Complete Syllabus of 9th to 12th with focus on IIT-JEE & NEET",
    },

    // Class 10th
    {
      category: "Class 10",
      name: "Sprout (C)",
      image: "sprout",
      eligibility: "9th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 10th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 10",
      name: "Sprout (C+)",
      image: "sprout",
      eligibility: "9th Pass",
      duration: "3 Years",
      description:
        "Complete Syllabus of 10th to 12th with focus on IIT-JEE & NEET",
    },
  ];

  return (
    <>
      <div id="heroBanner" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div className="row g-1">
              <div className="col-lg-6">
                <img
                  src="/assets/images/home/1.jpeg"
                  className="w-100 shadow position-relative z-1 bg-transparent object-fit-contain"
                  alt=""
                />
              </div>
              <div className="col-lg-6">
                <img
                  src="/assets/images/home/2.jpeg"
                  className="w-100 shadow position-relative z-1 bg-transparent object-fit-contain"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div className="row g-1">
              <div className="col-lg-6">
                <img
                  src="/assets/images/home/3.jpeg"
                  className="w-100 shadow position-relative z-1 bg-transparent object-fit-contain"
                  alt=""
                />
              </div>
              <div className="col-lg-6">
                <img
                  src="/assets/images/home/4.jpeg"
                  className="w-100 shadow position-relative z-1 bg-transparent object-fit-contain"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#heroBanner"
          data-bs-slide="prev"
        >
          <div class="button-md-circle">
            <i class="bi bi-chevron-left display-5 text-dark"></i>
          </div>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#heroBanner"
          data-bs-slide="next"
        >
          <div class="button-md-circle">
            <i class="bi bi-chevron-right display-5 text-dark"></i>
          </div>
        </button>
      </div>

      <section class="pt-lg-6 pb-lg-3 py-5">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="pe-lg-6">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4">
                  About <span className="fw-bold">Albedo Institute</span>
                </span>

                <h1 class="display-6 fw-bold my-2 ls-sm lh-1">
                  Albedo Institute Ranchi - IIT JEE Coaching
                </h1>
                <p class="mb-3 h3 lh-1">
                  Albedo Institute is a part of Albinstitute Pvt. Ltd, is a
                  premier educational institution based in Ranchi, Jharkhand.
                </p>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm">
                        The institution has a clear vision that inspires
                        in-depth educational interventions for students as they
                        navigate key transitions in their academic careers,
                        whether to an engineering-focused education or to
                        preparing for competitive school-level exams.
                      </p>
                    </div>
                    <div>
                      <h4 class="mb-1 fw-semibold">
                        How Albedo Institute Founded
                      </h4>
                      <p class="mb-0 fs-4 lh-sm">
                        Founded by a group of passionately-involved educators,
                        Albedo Institute committed to transforming learning into
                        an enjoyable and enriching experience.
                      </p>
                    </div>
                  </div>
                </div>
                <a
                  class="btn btn-dark px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5"
                  href="/introduction"
                >
                  About Us
                </a>
                <a
                  class="btn btn-outline-dark px-5 btn-md mt-3 py-1 rounded-pill ms-1 mb-lg-0 mb-5"
                  href="/introduction"
                >
                  Our Courses
                </a>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/1.jpg"
                class="object-fit-cover w-100 rounded-4"
                height="370"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="position-relative z-1 mt-4">
        <div class="container">
          <div class="blue-bg rounded-4 pt-3 pb-8 px-5 d-flex justify-content-center text-center">
            <div class="col-md-11 col-12 mt-4">
              <span class="text-white ls-md text-uppercase fw-semibold">
                Inspiring Minds. Empowering Futures.
              </span>
              <h2 class="display-6 text-white lh-1">
                Together, we don’t just prepare for exams — we prepare for the
                future.
              </h2>
              <p class="lead text-white opacity-75 px-lg-8 mb-5 fw-normal lh-sm mb-2">
                Our approach blends expert teaching, personalized mentorship,
                and structured learning paths to help students succeed
                academically while growing personally.
              </p>
              <div class="d-grid d-md-block mb-5">
                <a
                  class="btn btn-primary py-1 rounded-pill px-5 btn-md mb-2"
                  href="/mission-vision"
                >
                  Read More
                </a>
                <a
                  class="btn btn-light px-5 btn-md py-1 rounded-pill ms-1 mb-2"
                  href="/introduction"
                >
                  Download Brochure
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="container d-lg-block d-none">
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <div class="bg-white shadow rounded-pill mt-n8 border overflow-hidden">
                <div class="row justify-content-around py-3 gy-4 gy-lg-0">
                  <div class="col-md-8 px-5">
                    <img
                      src="assets/images/youtube-channel.png"
                      height="130"
                      draggable={false}
                    />
                  </div>
                  <div class="col-md-4 d-flex justify-content-center align-items-center flex-column px-4">
                    <a
                      href="https://www.youtube.com/@AlbedoJeeNeet"
                      class="btn btn-dark px-5 btn-md py-1 rounded-pill ms-1 mb-1"
                      target="_blank"
                    >
                      Subscribe Now
                    </a>
                    <a
                      href="https://www.youtube.com/@AlbedoJeeNeet"
                      target="_blank"
                    >
                      www.youtube.com/@AlbedoJeeNeet
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-2 bg-white">
        <div className="container">
          <div className="row mt-5 mb-2">
            <div className="col-md-12 col-12">
              <span class="text-black ls-md text-uppercase fw-semibold">
                Our Approach to Learning
              </span>
              <h2 className="mb-1 display-6 fw-bold text-dark lh-1 mt-1">
                Know more{" "}
                <u class="text-primary">
                  <span class="text-primary">about us</span>
                </u>
              </h2>
              <p className="lead text-dark lh-sm lh-1">
                Albedo Institute follows a student-centered approach that adapts
                to different learning styles & academic goals.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-12">
              <img
                src="/assets/images/6.webp"
                className="w-100 rounded-5 mb-lg-0 mb-4 object-fit-cover"
                height="350"
              />
            </div>
            <div className="col-lg-6 col-12 d-flex justify-content-center flex-column">
              <div className="ms-4">
                <div>
                  <p className="statistics__stat lh-1 m-0">4,800+</p>
                  <p className="fs-4 fs-normal m-0 lh-1 mt-2">
                    Selections in JEE Advanced
                  </p>
                </div>
                <div className="mt-2">
                  <p className="display-3 lh-1 m-0">12+</p>
                  <p className="fs-4 fs-normal m-0 lh-1 mt-1">
                    Years of Offline Coaching
                  </p>
                </div>
                <div className="mt-2">
                  <p className="display-3 lh-1 m-0">3,600</p>
                  <p className="fs-4 fs-normal m-0 lh-1 mt-1">
                    Selections in JEE Main
                  </p>
                </div>
                <div className="mt-3">
                  <a
                    class="btn btn-outline-dark px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5 me-1"
                    href="/introduction"
                  >
                    About Albedo Institute
                  </a>
                  <a
                    class="btn btn-dark px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5"
                    href="/introduction"
                  >
                    Our Courses
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mb-7">
          <div className="row">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <div className="row mt-5">
                <div className="col-md-10 col-12">
                  <span class="text-dark ls-md text-uppercase fw-semibold">
                    Programs Designed for Success
                  </span>
                  <h2 className="mb-1 display-6 fw-bold text-dark lh-1">
                    Structured courses tailored to{" "}
                    <u class="text-primary">
                      <span class="text-primary">different academic goals</span>
                    </u>
                  </h2>
                  <p className="fs-4 text-secondary fw-normal lh-sm mt-2 mb-0">
                    Each program is designed with a balanced focus on conceptual
                    understanding, practice, and assessment, ensuring students
                    progress with clarity and confidence at every stage of their
                    academic journey.
                  </p>
                  <div className="mb-2">
                    <a
                      class="btn btn-outline-dark px-5 btn-md mt-3 py-1 rounded-pill me-1"
                      href="/introduction"
                    >
                      About Albedo Institute
                    </a>
                    <a
                      class="btn btn-dark px-5 btn-md mt-3 py-1 rounded-pill"
                      href="/introduction"
                    >
                      Our Courses
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-2 mt-2">
              {courses.map((course, index) => (
                <div className="col-lg-4 col-12" key={index}>
                  <div className="row g-0 rounded-5 h-100">
                    <div className="col-12 px-4 d-flex align-items-center bg-light pb-3 pt-2 rounded-4">
                      <div>
                        <img
                          src={`/assets/images/${course.image}.jpg`}
                          height="80"
                          className="rounded-3"
                        />
                      </div>
                      <div className="d-flex flex-column ps-4 pe-2 mb-2">
                        <div className="d-flex flex-column mt-3">
                          <h3 className="mb-0 lh-1">
                            <a href="#" className="fs-4 text-dark">
                              {course.name} Course
                            </a>
                          </h3>

                          <p className="mb-0 lh-sm mt-1 mb-0">
                            {course.description}. <br />
                            <br />
                            Course Duration — {course.duration}.
                          </p>

                          <span className="text-gray-500">
                            Eligibility — <a href="#">{course.eligibility}</a>
                          </span>
                        </div>

                        <div className="mt-3">
                          <a
                            className="btn bg-gold text-dark px-5 py-1 rounded-pill border-0"
                            href="/"
                          >
                            Enroll Now
                          </a>

                          <a
                            className="btn btn-icon btn-success btn-sm rounded-circle d-none d-md-inline-flex ms-1"
                            href="/"
                          >
                            <i className="bi bi-whatsapp fs-4 align-middle" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="px-8">
                      <div className="bg-danger pt-1 mt-n1"></div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="col-lg-4 col-12">
                <div className="row g-0 rounded-5 h-100">
                  <div className="col-12 px-4 bg-dark pb-3 pt-2 rounded-4 d-flex justify-content-center align-items-center">
                    <div className="text-center text-white mt-lg-0 mt-4">
                      <span className="badge bg-white-soft mb-2 rounded-pill fs-5 px-4">
                        Enroll Now
                      </span>
                      <h4 className="text-white fs-3 m-0 lh-1">
                        Enroll for Courses at Albedo
                      </h4>
                      <p className="mb-1">
                        Begin Your Journey Toward Academic Excellence
                      </p>

                      <a
                        class="btn btn-white px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5 me-1"
                        href="/introduction"
                      >
                        Albedo Registration Form
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-5 bg-image pb-8 d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-10 col-md-12">
              <div className="position-relative z-3">
                <h1 className="display-5 ls-sm mb-2 fw-bold text-white">
                  Why Choose Albedo Institute?
                </h1>
                <p className="lead text-white lh-sm lh-1">
                  At Albedo Institute, students don’t just study—they grow. We
                  provide a supportive, motivating environment that builds
                  confidence, strengthens academic skills, and inspires students
                  to aim higher.
                </p>
                <div className="mt-3">
                  <a
                    class="btn btn-white px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5 me-1"
                    href="/introduction"
                  >
                    Our Courses
                  </a>
                  <a
                    class="btn btn-outline-light px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5"
                    href="/introduction"
                  >
                    Know More About Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pb-3 pt-6">
        <div class="container">
          <div class="row mb-2">
            <div class="row text-center">
              <div class="col-md-12 px-lg-8">
                <span class="text-uppercase text-secondary fw-semibold ls-md">
                  TESTIMONIAL
                </span>
                <h2 class="fw-semibold ls-sm text-success lh-1">
                  That’s What Our Students Say
                </h2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-12">
              <div>
                <span class="text-uppercase fw-semibold text-danger fs-4 ls-sm">
                  Happy Faces
                </span>
                <h2 class="fw-semibold ls-sm text-dark lh-1 mt-1">
                  Experiences Shared by Our Learners
                </h2>
                <p class="lead lh-sm mb-4">
                  Authentic experiences that reflect comfort, care, and
                  hospitality. Memorable stays shaped by warm service and
                  thoughtful details.
                </p>
                <a
                  href="https://www.google.com/search?num=10&sca_esv=cf1eceaa70d19ffa&sxsrf=ANbL-n7FQN5c5wABuaZ-OKtTb3P5LqvQ9g:1770525706843&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qORzcSuKFKqbnRXZCEInxqDbT_IVvjiDTmIWL_kzGnp2sWmTwQatrLxkQR9skfgdRwsXQ-Rbowc6FVxReEp8S93oeByrTX87OlI-AlD7IzEmbFwmO7g%3D%3D&q=Albedo+Institute+Reviews&sa=X&ved=2ahUKEwjv48ieismSAxXNoWMGHQRNHPQQ0bkNegQIIxAH&biw=1528&bih=732&dpr=1.25"
                  target="_blank"
                  class="btn border-1 bg-dark text-white fw-normal w-auto me-2 px-5 me-lg-0 rounded-pill"
                >
                  Google Reviews
                </a>
              </div>
            </div>
            <div class="col-lg-8 col-12">
              <div
                id="testimonialBanner"
                class="carousel slide"
                data-bs-ride="carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="px-8 d-flex align-items-center pb-4 pt-1">
                      <div class="d-flex flex-column px-2 mx-lg-8">
                        <div class="d-flex flex-column gap-3 mt-4">
                          <div class="d-flex flex-column">
                            <p class="mb-0 lh-sm mt-1 mb-2 fs-4">
                              I am Priyanshu Kumar from Harmu, Ranchi, and I
                              study in Class 11. Albedo Institute has been a
                              great place for my IIT-JEE preparation. The
                              teachers explain everything in a simple way,
                              making tough topics easy to understand.
                            </p>
                            <div class="mt-2">
                              <span class="text-dark fs-3 m-0 lh-1 mt-2 fw-medium ls-1">
                                Priyanshu Kumar
                              </span>
                              <p class="mb-0 lh-sm m-0 fs-5 text-dark">
                                08/04/2025
                              </p>
                            </div>
                          </div>
                          <div class="lh-1">
                            <span class="text-secondary fw-semibold">5</span>
                            <span class="align-text-top ms-2">
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="px-8 d-flex align-items-center pb-4 pt-1">
                      <div class="d-flex flex-column px-2 mx-lg-8">
                        <div class="d-flex flex-column gap-3 mt-4">
                          <div class="d-flex flex-column">
                            <p class="mb-0 lh-sm mt-1 mb-2 fs-4">
                              I had a great experience at Albedo Institute while
                              preparing for JEE. The teachers are knowledgeable,
                              and the environment is very student-friendly. They
                              focus not just on solving problems but also on
                              building strong conceptual understanding.
                            </p>
                            <div class="mt-2">
                              <span class="text-dark fs-3 m-0 lh-1 mt-2 fw-medium ls-1">
                                Aditya Ayush
                              </span>
                              <p class="mb-0 lh-sm m-0 fs-5 text-dark">
                                18/05/2025
                              </p>
                            </div>
                          </div>
                          <div class="lh-1">
                            <span class="text-secondary fw-semibold">4.5</span>
                            <span class="align-text-top ms-2">
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="px-8 d-flex align-items-center pb-4 pt-1">
                      <div class="d-flex flex-column px-2 mx-lg-8">
                        <div class="d-flex flex-column gap-3 mt-4">
                          <div class="d-flex flex-column">
                            <p class="mb-0 lh-sm mt-1 mb-2 fs-4">
                              Albedo Institute has been an incredible support
                              system for my JEE preparation. The faculty is
                              highly experienced, with a deep understanding of
                              the exam patterns and concepts.
                            </p>
                            <div class="mt-2">
                              <span class="text-dark fs-3 m-0 lh-1 mt-2 fw-medium ls-1">
                                Shivam Kumar
                              </span>
                              <p class="mb-0 lh-sm m-0 fs-5 text-dark">
                                23/08/2025
                              </p>
                            </div>
                          </div>
                          <div class="lh-1">
                            <span class="text-secondary fw-semibold">5</span>
                            <span class="align-text-top ms-2">
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                              <i class="bi bi-star-fill text-warning me-1"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5">
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#testimonialBanner"
                    data-bs-slide="prev"
                  >
                    <div class="button-md-circle bg-secondary">
                      <i class="bi bi-chevron-left display-5 text-white"></i>
                    </div>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#testimonialBanner"
                    data-bs-slide="next"
                  >
                    <div class="button-md-circle bg-secondary">
                      <i class="bi bi-chevron-right display-5 text-white"></i>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pb-lg-7 pb-5">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-8 col-md-12 col-12">
              <div class="pe-lg-6">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4">
                  Albedo Scholarship Programme
                </span>

                <h1 class="display-6 fw-bold my-2 ls-sm lh-1">
                  Selection Test for Albedo Merit Programme - STAMP
                </h1>
                <p class="mb-3 h3 lh-1">Advantage of STAMP</p>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm">
                        <ul>
                          <li>100% Scholarship to 40 students Each Class.</li>
                          <li>All IITian Faculties in IIT-JEE Division.</li>
                          <li> MBBS (Doctors) Faculties in NEET Division.</li>
                          <li>
                            Study Pattern based on NEP (New education policy)
                          </li>
                          <li>
                            24 Hour, Faculty observation, Hostel facility.
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div>
                      <h4 class="mb-1 fw-semibold text-danger">
                        Online Registration Scan QR code
                      </h4>
                    </div>
                  </div>
                </div>
                <a
                  class="btn btn-dark px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5"
                  href="/"
                >
                  Download Brochure
                </a>
                <a
                  class="btn btn-outline-dark px-5 btn-md mt-3 py-1 rounded-pill ms-1 mb-lg-0 mb-5"
                  href="/introduction"
                >
                  Our Courses
                </a>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12 d-flex align-items-center justify-content-end">
              <div className="rounded-5 bg-light p-5">
                <img
                  src="/assets/images/qr-code.png"
                  class="object-fit-contain w-100 rounded-3"
                  height="250"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-success">
        <div className="container">
          <div className="py-5 rounded-5">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <h5 class="mb-0 fs-3 fw-normal lh-sm text-light text-uppercase">
                  our mission is to make
                </h5>
                <h2 class="h1 text-white fw-normal ls-sm lh-1">
                  learning meaningful and future-ready.
                </h2>
              </div>
              <div className="col-lg-4 d-flex flex-column justify-content-center">
                <p className="m-0 text-white">Trusted by</p>
                <p className="text-stroke m-0 display-1">20,000 +</p>
                <p className="m-0 text-white mt-1">
                  students—past and present.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 bg-white">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="row text-center d-flex justify-content-center">
                <div class="col-lg-7 col-md-12 px-lg-8 mb-3">
                  <h2 class="fw-bold text-dark mb-0">
                    Here's everything you{" "}
                    <u class="text-dark">
                      <span class="text-dark">may ask?</span>
                    </u>{" "}
                  </h2>
                  <p class="lead text-dark opacity-75 lh-1 mt-1">
                    Got questions? Find all the answers here about Albedo
                    Institute, our courses, and admission process.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-10 pb-lg-0 pb-3 d-flex align-items-center">
              <div
                class="accordion accordion-flush w-100 pe-lg-5 pe-0 me-lg-5 me-0"
                id="accordionFlushExample"
              >
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 blue-bg px-5 rounded-pill py-2"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      <h3 class="fs-5 text-white fw-medium m-0 py-1">
                        What will be the duration of the course?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                        The duration of courses at Albedo Institute varies based
                        on the program and academic level selected. Some courses
                        are designed as short-term modules, while others extend
                        over several months or an academic year. Each program
                        follows a structured schedule with regular classes,
                        practice sessions, and revisions to ensure steady
                        academic progress. Complete course timelines are shared
                        during enrollment to help students and parents plan
                        effectively.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item mt-2">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill py-2 collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h3 class="fs-5 text-dark fw-medium m-0 py-1">
                        Is the learning environment safe and private?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    class="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                        Yes, Albedo Institute ensures a safe, disciplined, and
                        student-friendly learning environment. We maintain high
                        standards of privacy, professionalism, and academic
                        integrity in both offline and online learning modes. Our
                        classrooms promote respectful interaction and focused
                        learning, allowing students to engage confidently and
                        comfortably throughout their academic journey.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item mt-2">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill py-2 collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h3 class="fs-5 text-dark fw-medium m-0 py-1">
                        What will I learn in this course?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                        Students at Albedo Institute gain strong conceptual
                        understanding in core subjects along with exam-oriented
                        strategies. Our courses focus on clarity,
                        problem-solving skills, disciplined study habits, and
                        confidence building. Beyond academics, we emphasize
                        analytical thinking, time management, and consistency to
                        help students succeed in exams and future academic
                        challenges.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item mt-2">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill py-2 collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      <h3 class="fs-5 text-dark fw-medium m-0 py-1">
                        Can I enroll in more than one course together?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                        Yes, students may enroll in more than one course if the
                        schedules align well. Our academic counselors assist in
                        selecting the right combination of programs based on
                        learning capacity and goals. This ensures balanced
                        preparation without unnecessary academic pressure.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item mt-2">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill py-2 collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFive"
                      aria-expanded="false"
                      aria-controls="flush-collapseFive"
                    >
                      <h3 class="fs-5 text-dark fw-medium m-0 py-1">
                        Do we get access to recorded sessions?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFive"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                        Yes, depending on the course, students may receive
                        access to recorded sessions and study resources. These
                        recordings help revise important topics, clarify doubts,
                        and support learning at one’s own pace. Access details
                        are clearly communicated at the time of enrollment.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item mt-2">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill py-2 collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSix"
                      aria-expanded="false"
                      aria-controls="flush-collapseSix"
                    >
                      <h3 class="fs-5 text-dark fw-medium m-0 py-1">
                        What benefits do students get after enrolling?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSix"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                        Students benefit from expert faculty guidance,
                        structured study materials, regular assessments,
                        mentorship support, and a motivating learning
                        environment. Our focus is to build confidence, improve
                        academic performance, and develop disciplined learning
                        habits.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="accordion-item mt-2">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill py-2 collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSeven"
                      aria-expanded="false"
                      aria-controls="flush-collapseSeven"
                    >
                      <h3 class="fs-5 text-dark fw-medium m-0 py-1">
                        Is mentorship support available?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSeven"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 text-dark opacity-75 lh-sm">
                        Yes, mentorship is an integral part of the Albedo
                        Institute learning experience. Our faculty members guide
                        students academically and personally, helping them stay
                        motivated, manage challenges, and remain focused
                        throughout their educational journey.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4 text-center">
              <a href="#" class="lead lh-1 fs-4">
                More questions? Visit the Help Center{" "}
                <i className="bi bi-arrow-right fs-4 ms-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-2">
          <div className="row align-items-end">
            <div className="col-lg-6 mt-6">
              <span className="text-uppercase text-danger fw-semibold ls-md">
                Awards & Recognition
              </span>
              <h2 className="fw-normal ls-sm text-warning lh-1">
                Recognizing dedication, discipline, and{" "}
                <span className="fw-bold">academic excellence</span>.
              </h2>
              <p className="fs-4 text-white lh-sm lh-1 mt-3">
                At Albedo Institute, awards and recognitions are more than
                milestones—they are reflections of our commitment to quality
                education and disciplined learning.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="d-flex justify-content-center mt-5">
                <iframe
                  height={340}
                  src="https://www.youtube.com/embed/XOAQNK3dlHI?si=xzykSqCw34x6yOT_"
                  frameBorder={0}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  className="w-100 object-fit-cover rounded-4"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="blue-bg p-8 mt-n10">
          <div className="p-8 m-2" />
        </div>
      </section>
    </>
  );
}

export default Home;
